"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function BilingualSupport() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section ref={sectionRef} className="relative py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <Card className="bg-card text-card-foreground shadow-medium border border-border">
            <CardContent className="flex items-center justify-center py-12">
              <img src="https://rational-stag.10web.cloud/wp-content/uploads/2026/01/logo-1.png" alt="Salem Ballama Auditing" className="max-w-full max-h-[600px] w-auto h-auto rounded-lg shadow-soft object-contain" />
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}